module.exports = __webpack_public_path__ + "img/image2.a444c90b.jpg";